(function () {
  function scrollStep(elScroll, direction) {
    var card = elScroll.querySelector('.cclp-shade-grid__card');
    if (!card) return 0;
    var styles = window.getComputedStyle(elScroll);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return (card.offsetWidth + gap) * direction;
  }

  class CclpShadeCarousel extends HTMLElement {
    constructor() {
      super();
      this._onPrev = this._onPrev.bind(this);
      this._onNext = this._onNext.bind(this);
    }

    connectedCallback() {
      this.elScroll = this.querySelector('[data-scroll]');
      this.btnPrev = this.querySelector('[data-prev]');
      this.btnNext = this.querySelector('[data-next]');
      if (this.btnPrev) this.btnPrev.addEventListener('click', this._onPrev);
      if (this.btnNext) this.btnNext.addEventListener('click', this._onNext);
    }

    disconnectedCallback() {
      if (this.btnPrev) this.btnPrev.removeEventListener('click', this._onPrev);
      if (this.btnNext) this.btnNext.removeEventListener('click', this._onNext);
    }

    _onPrev() {
      if (!this.elScroll) return;
      var dx = scrollStep(this.elScroll, -1);
      this.elScroll.scrollBy({ left: dx, behavior: 'smooth' });
    }

    _onNext() {
      if (!this.elScroll) return;
      var dx = scrollStep(this.elScroll, 1);
      this.elScroll.scrollBy({ left: dx, behavior: 'smooth' });
    }
  }

  if (!customElements.get('cclp-shade-carousel')) {
    customElements.define('cclp-shade-carousel', CclpShadeCarousel);
  }
})();
